import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import { RoomContext } from './context/RoomContext';
import VideoRoom from './VideoRoom';
import './ui/index.css';
import VideoRoomLobby from './VideoRoomLobby';
import { SdkContext } from './context/SdkContext';
import { Omnitalk } from 'omnitalk-ts-sdk';

function Main() {
	let SERVICE_ID, SERVICE_KEY;
	// let sdk;
	const [roomInfo, setRoomInfo] = useState({ hasEnteredRoom: false });
	const [sdk, setSdk] = useState(null);
	async function getServiceKey() {
		try {
			const response = await fetch(
				'https://omnitalk.io:3001/users/domain-service',
			);
			const servicekeyResult = await response.json();
			SERVICE_ID = servicekeyResult.data.service_id;
			SERVICE_KEY = servicekeyResult.data.service_key;
		} catch (error) {
			console.log(error);
		}
	}
	async function init() {
		await getServiceKey();
		Omnitalk.sdkInit(SERVICE_ID, SERVICE_KEY);
		const instance = Omnitalk.getInstance();
		setSdk(instance);
	}
	useEffect(() => {
		init(); // Call the init function only once after the component has mounted
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	return (
		<SdkContext.Provider value={sdk}>
			<RoomContext.Provider value={{ roomInfo, setRoomInfo }}>
				{roomInfo.hasEnteredRoom ? <VideoRoom /> : <VideoRoomLobby />}
			</RoomContext.Provider>
		</SdkContext.Provider>
	);
}

ReactDOM.createRoot(document.getElementById("root")).render(<Main />);
